import React, { useState } from "react";
import { HTTP } from "../../api/resources";
import NoteForm from "./NoteForm";
import Moment from "react-moment";

const NotesListItem = ({ note, handleUpdate, project, user }) => {
  const [editing, setEditing] = useState(false);

  const handleDelete = () => {
    let url = `/notes/${note.id}.json`;

    HTTP.delete(url, {
      params: { user_id: note.user_id },
    })
      .then(() => {
        handleUpdate();
      })
      .catch(() => {
        Alert.show("error", "Could not update. Try again or refresh.");
      });
  };

  return (
    <div id={`notes-table-${note.id}`} className="list-group-item">
      <div className="list-group-item-body">
        <div>
          <span className="mr-1">
            <div className="mb-1">
              <span className="badge badge-warning badge-pill mr-1">
                {note.creator_type}
              </span>
              <span title={note.created_at}>
                <Moment fromNow>{note.created_at}</Moment>
              </span>

            </div>
            <div className="list-group-item-actions-mobile">
        <button
          onClick={() => setEditing(true)}
          className="btn btn-sm btn-primary mr-1"
        >
          Edit
        </button>
        <button
          onClick={() => {
            if (window.confirm("Are you sure you wish to delete this note?"))
              handleDelete();
          }}
          className="btn btn-sm btn-danger"
        >
          Delete
        </button>
      </div>
            <div>{note.content}</div>
          </span>
        </div>
      </div>
      <div className="list-group-item-actions d-none-mobile">
        <button
          onClick={() => setEditing(true)}
          className="btn btn-sm btn-primary mr-1"
        >
          Edit
        </button>
        <button
          onClick={() => {
            if (window.confirm("Are you sure you wish to delete this note?"))
              handleDelete();
          }}
          className="btn btn-sm btn-danger"
        >
          Delete
        </button>
      </div>

      {editing && (
        <NoteForm
          note={note}
          updateNote={handleUpdate}
          close={() => setEditing(false)}
          project={project}
          user={user}
        />
      )}
    </div>
  );
};

export default NotesListItem;
